<template>
    <b-container>
        <builder-progress-bar :serial="serial" :progress-step="progressStep" />
        <builder-item :id="'builder-step-' + (index + 1)" :key="part.key" :pkey="part.key" :items="part.items" v-for="(part, index) in parts" @picked="onPartPicked" />
    </b-container>
</template>

<script>
    import Vue from 'vue'
    import VueScrollTo from 'vue-scrollto'

    import BuilderProgressBar from "./ProgressBar"
    import BuilderItem from "./Item"

    import { groupBy } from "../../utils/misc"

    let getDefaultData = function () {
        return {
            serial: '',
            progressStep: 0,
            parts: []
        }
    }

    export default {
        components: {
            BuilderProgressBar,
            BuilderItem
        },

        created () {
            this.reset()    // clear all data

            this.fetchData()
        },

        methods: {

            fetchData (partKey = false) {
                let resourceUrl = partKey
                    ? `api/parts/${partKey}`
                    : 'api/parts'

                // -----------------------------------------
                this.$http.get(resourceUrl).then(response => {

                    let results = response.data.results
                    if (results) {
                        this.serial = results.serial

                        let is_final = results.final || false
                        if (is_final) {
                            this.progressStep = 10

                            return this.$emit('result', {serial: results.serial, parts: results.parts})
                        }
                    }

                    // --------------------------------------------------------------------------------

                    let items = response.data.items.map(item => {

                        let result = { id: item.id, title: item.data.join(' ')}
                        if (partKey === false) {
                            result.category = item.category
                            result.position = item.category_position
                        }

                        return result
                    })

                    if (partKey === false) {
                        // sort by position
                        items.sort((a, b) => (a.position > b.position) ? 1 : -1)

                        // hide hidden category
                        items = items.filter(item => item.category.toLowerCase() !== 'hidden')
                        items = groupBy(items, 'category')
                    }

                    this.parts.push({
                        key: partKey,
                        items
                    })

                    Vue.nextTick(() => {
                        VueScrollTo.scrollTo(`div#builder-step-${this.parts.length}`)
                    })

                })
            },

            onPartPicked (data, type = 'created') {
                if (type == 'changed') {
                    // in case user wants to change in the middle of picker
                    const lastIndex = this.parts.findIndex(part => part.key == data.key)
                    this.parts.splice(lastIndex + 1, this.parts.length)
                }

                // load next data (if not final)
                let nextPartKey = (this.parts.length > 1)
                    ? `${data.key}-${data.selected.id}`
                    : data.selected.id

                this.fetchData(nextPartKey)

                this.progressStep = this.parts.length
            },

            reset () {
                Object.assign(this.$data, getDefaultData())
            }
        },

        data: getDefaultData
    }
</script>

<style scoped>
    .container {
        margin-top: 50px
    }
    @media (min-width: 576px) {
        .modal-dialog {
            max-width: 900px!important; 
        }
    }
</style>
